import { SupportTicketAttachmentDetailsMapper } from '../SupportTicketAttachmentDetails/SupportTicketAttachmentDetailsMapper.js';

class SupportTicketCommonDataMapper {
  static createModelFromResponse(response) {
    return {
      reason: response.reason,
      additionalPicture: response.additional_picture,
      additionalPictureAttachmentDetail: SupportTicketAttachmentDetailsMapper.createModelFromResponse(response.additional_picture_attachment_detail)
    };
  }
  static createApiPayload(_ref) {
    let {
      reason,
      additionalPicture
    } = _ref;
    return {
      reason,
      additional_picture: additionalPicture || undefined
    };
  }
}

export { SupportTicketCommonDataMapper };
//# sourceMappingURL=SupportTicketCommonData.js.map
